(function(){
  if(!window.theme)window.theme={};
  if(window.theme.fetchCache)return;
  const cache=new Map(),inFlight=new Map();
  window.theme.fetchCache={
    preload(url){
      if(cache.has(url)||inFlight.has(url))return;
      const p=fetch(url,{credentials:'same-origin'})
        .then(r=>r.ok?r.text():Promise.reject(r.status))
        .then(html=>{cache.set(url,html);inFlight.delete(url);return html;})
        .catch(e=>{inFlight.delete(url);console.warn('[fetch-cache] preload failed:',url,e);});
      inFlight.set(url,p);
    },
    fetch(url){
      if(cache.has(url))return Promise.resolve(cache.get(url));
      if(inFlight.has(url))return inFlight.get(url);
      const p=fetch(url,{credentials:'same-origin'})
        .then(r=>r.ok?r.text():Promise.reject(r.status))
        .then(html=>{cache.set(url,html);inFlight.delete(url);return html;})
        .catch(e=>{inFlight.delete(url);return Promise.reject(e);});
      inFlight.set(url,p);
      return p;
    },
    clear(url){
      if(url){cache.delete(url);inFlight.delete(url);}
      else{cache.clear();inFlight.clear();}
    }
  };
})();